import api from "@app/config/api/api";

export const userDetailsOptions = api.queryOptions("get", "/iam/user/", {
  queryKey: ["iam", "user"]
});
